import * as TYPES from './constants';
import {
  requestReportRun,
  receiveReportRun,
  handleReportRunError,
} from './actions';

import {API, JSON_HEADER, JWT_HEADER} from 'config/srm.config';

const initialState = {
  data: null,
  request: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_REPORT_RUN:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_REPORT_RUN:
      return {
        ...state,
        data: action.payload,
        request: false,
        error: false,
      };
    case TYPES.REPORT_RUN_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    default:
      return state;
  }
};

export const fetchReportRun = data => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    method: data ? 'POST' : 'GET',
    mode: 'cors',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
    cache: 'default',
  };
  if (data) {
    config.body = JSON.stringify(data);
  }
  dispatch(requestReportRun());
  try {
    return fetch(`${API.reports.report_run}`, config)
      .then(response => response.json())
      .then(json => {
        dispatch(receiveReportRun(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleReportRunError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleReportRunError(err));
  }
};
